import {useSelector} from "react-redux";
import {isPending} from "state/selectors/ui";
import {useNodeData} from "./useNodeData";

export function useNodeExists(id) {
    const {id: nodeId} = useNodeData(id);
    const pending = useSelector(s=>isPending(s, id));
    if (pending) return true;
    return !!nodeId;
}